module.exports = __webpack_public_path__ + "img/coomecipar.cf46aba1.png";